module.exports = __webpack_public_path__ + "static/media/article9.94e31d73.webp";